import { render } from "./contenteditable.vue?vue&type=template&id=9f7ba9ca"
import script from "./contenteditable.vue?vue&type=script&lang=js"
export * from "./contenteditable.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__